export const GetPropsMenu = (path) => {
  var defaultSelectedKeys = "managerial";
  switch (path) {
    case "/app/client/managerial":
      defaultSelectedKeys = "managerial";
      break;
    case "/app/client/reviews":
      defaultSelectedKeys = "reviews";
      break;
    case "/app/client/planning":
      defaultSelectedKeys = "planning";
      break;
    case "/app/client/load-control":
      defaultSelectedKeys = "control";
      break;
    case "/app/client/users":
      defaultSelectedKeys = "users";
      break;
    case "/app/client/ranking":
      defaultSelectedKeys = "ranking";
      break;
    case "/app/client/trainning":
      defaultSelectedKeys = "trainning";
      break;
    case "/app/client/branches":
      defaultSelectedKeys = "branches";
      break;
    default:
      break;
  }
  return { defaultSelectedKeys };
};
